import { useState, useEffect } from "react";
import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import HeroSection from "./components/HeroSection";
import SocialProof from "./components/SocialProof";
import FeaturedService from "./components/FeaturedService";
import ServicesGrid from "./components/ServicesGrid";
import DiscoverSisters from "./components/DiscoverSisters";
import TestimonialsSection from "./components/TestimonialsSection";
import ProductFeature from "./components/ProductFeature";
import TeamSection from "./components/TeamSection";
import AwardsSection from "./components/AwardsSection";
import ImpactSection from "./components/ImpactSection";
import SustainabilitySection from "./components/SustainabilitySection";
import InstagramSection from "./components/InstagramSection";

function WhatsAppButton() {
  const [visible, setVisible] = useState(false);
  const [tooltip, setTooltip] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 1500);
    const tooltipTimer = setTimeout(() => setTooltip(false), 5000);
    return () => {
      clearTimeout(timer);
      clearTimeout(tooltipTimer);
    };
  }, []);

  return (
    <div
      className={`fixed bottom-6 right-4 sm:right-6 z-50 flex flex-col items-end gap-2 transition-all duration-500 ${
        visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"
      }`}
    >
      {tooltip && (
        <div className="bg-white border border-[#e5e0d5] text-[#1a2744] text-xs px-3 py-2 max-w-[180px] text-right leading-relaxed">
          <p className="font-medium">Book via WhatsApp!</p>
          <p className="text-gray-400 text-xs" style={{ fontFamily: "'Noto Naskh Arabic', serif" }}>احجزي عبر واتساب</p>
        </div>
      )}
      <a
        href="https://api.whatsapp.com/send?phone=96892102051&text=Hello%20Blue%20Moon%20Beauty%20Salon%20%26%20Spa%2C%20I%20would%20like%20more%20information%20about%20your%20services."
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat on WhatsApp - Blue Moon Beauty Salon Muscat"
        className="w-14 h-14 bg-[#25D366] flex items-center justify-center hover:bg-[#20ba5a] transition-colors duration-300 cursor-pointer"
        style={{ borderRadius: "50%" }}
      >
        <i className="ri-whatsapp-line text-white text-2xl"></i>
      </a>
    </div>
  );
}

export default function Home() {
  return (
    <div className="w-full overflow-x-hidden">
      <Navbar />
      <main>
        <HeroSection />
        <SocialProof />
        <FeaturedService />
        <section id="services">
          <ServicesGrid />
        </section>
        <section id="about">
          <DiscoverSisters />
        </section>
        <TestimonialsSection />
        <ProductFeature />
        <section id="team">
          <TeamSection />
        </section>
        <AwardsSection />
        <ImpactSection />
        <SustainabilitySection />
        <section id="gallery">
          <InstagramSection />
        </section>
      </main>
      <section id="contact">
        <Footer />
      </section>
      <WhatsAppButton />
    </div>
  );
}
